import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '@/lib/utils'

import { Label } from './label'

let idCounter = 0

interface CheckboxProps extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  label?: string
  labelClassName?: string
}

function Checkbox({ className, label, labelClassName, id, ...props }: CheckboxProps) {
  const checkboxIdRef = React.useRef<string | null>(null)

  if (!checkboxIdRef.current) {
    checkboxIdRef.current = `checkbox-${++idCounter}`
  }

  const finalId = id || checkboxIdRef.current

  const checkbox = (
    <CheckboxPrimitive.Root
      id={finalId}
      data-slot='checkbox'
      className={cn(
        'peer border-text-secondary dark:bg-input/30 data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-icon-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex size-4 shrink-0 items-center justify-center rounded-full border p-[2px] transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='bg-icon-primary flex size-full items-center justify-center rounded-full'
      ></CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )

  if (label) {
    return (
      <div className='flex items-center gap-2'>
        {checkbox}
        <Label className={cn('mb-0', labelClassName)} htmlFor={finalId}>
          {label}
        </Label>
      </div>
    )
  }

  return checkbox
}

export { Checkbox }
